import {Component, Input, OnInit} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import * as _ from 'lodash';

@Component({
  selector: 'app-read-service-radios',
  templateUrl: './read-service-radios.component.html',
  styleUrls: ['./read-service-radios.component.css']
})
export class ReadServiceRadiosComponent implements OnInit {

  @Input() oneComponent: any;
  @Input() componentIndex: any;
  @Input() oneSmallGroup: any;
  @Input() smallGroupIndex: any;
  @Input() groupIndex: any;
  @Input() serviceData: any;
  componentModalVisible: any;
  componentDatas = {};

  constructor() {
  }

  ngOnInit() {
  }

}
